import "../css/constants.css";
import React, { useState } from "react";
import {scroller, animateScroll, Link as ScrollLink} from "react-scroll";
import {Link, useLocation, useNavigate} from "react-router-dom";
import { ChevronDown } from "lucide-react";
import GlobalTexts from "../assets/jsons/Global.json";
import FaqsTexts from "../assets/jsons/faq.json";

export default function Footer({ language }) {
    const location = useLocation();
    const navigate = useNavigate();

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const [openFAQIndex, setOpenFAQIndex] = useState(null);
    const [faqVisible, setFAQVisible] = useState(false);

    const faqs = [
        {
            question: "Comment réserver un vol privé avec Avanty Jet ?",
            answer: `Il vous suffit de nous contacter via notre formulaire dédié ou directement par téléphone.
Un gestionnaire de vol privé vous sera immédiatement attribué pour orchestrer votre mission de manière personnalisée et confidentielle.`,
        },
        {
            question: "Sous quel délai pouvez-vous organiser un vol ?",
            answer: `Nous sommes capables d'organiser un vol privé en moins de 2 heures selon la disponibilité des appareils et des aéroports.
Notre cellule opérationnelle est disponible 24/7, y compris les jours fériés.`,
        },
        {
            question: "Quelles garanties de sécurité proposez-vous ?",
            answer: `Tous les appareils proposés par Avanty Jet sont opérés par des partenaires certifiés selon les standards les plus stricts (EASA OPS, ARGUS Platinum, Wyvern Wingman).
Chaque vol fait l'objet d'une double vérification technique et opérationnelle avant départ.`,
        },
        {
            question: "Puis-je personnaliser mon expérience de vol ?",
            answer: `Absolument.
Avanty Jet propose une personnalisation complète de votre vol : restauration à bord, choix de l’équipage, configuration cabine, playlist musicale, confort spécifique, services annexes au sol et en vol.`,
        },
//         {
//             question: "Quels types d'appareils sont disponibles ?",
//             answer: `Notre flotte couvre tous les segments :
// • Turbopropulseurs pour les vols régionaux.
// • Light Jets et Midsize Jets pour les trajets continentaux rapides.
// • Heavy Jets et Ultra Long Range pour les longues distances et vols intercontinentaux.
// Votre gestionnaire vous conseillera le modèle idéal selon votre besoin précis.`,
//         },
//         {
//             question: "Proposez-vous des vols \"Empty Legs\" ?",
//             answer: `Oui.
// Avanty Jet propose une sélection exclusive d'Empty Legs actualisée en temps réel.
// Nos experts peuvent également surveiller pour vous les meilleures opportunités correspondant à votre itinéraire souhaité.`,
//         },
//         {
//             question: "Comment la confidentialité est-elle assurée ?",
//             answer: `La confidentialité absolue est une valeur fondatrice d'Avanty Jet.
// Toutes vos informations personnelles, vos itinéraires et vos préférences sont traités selon des protocoles de protection stricts, et uniquement accessibles aux équipes directement impliquées dans la réalisation de votre mission.`,
//         },
    ];

    const toggleFAQVisibility = () => {
        setFAQVisible(!faqVisible);
        setOpenFAQIndex(null);
    };

    const toggleFAQ = (index) => {
        setOpenFAQIndex(openFAQIndex === index ? null : index);
    };

    const scrollToOrNavigate = (path, section = null) => {
        if (location.pathname === path) {
            if (section) {
                scroller.scrollTo(section, { smooth: true, duration: 800, offset: -68 });
            } else {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        } else {
            window.scrollTo({ top: 0, duration: 0 });
            navigate(path);
        }
    };

    return (
        <footer className="bg-myWhite text-myDarkBlue pt-12 pb-16 px-4 sm:px-8 lg:px-20">
            <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row gap-6">

                {/* Logo */}
                <div onClick={() => {window.scrollTo({ top: 0, duration: 0 }); navigate("/")}} className="flex flex-col items-center lg:items-start w-full lg:w-1/6">
                    <img src="/logo.png" alt="AvantyJet Logo" className="w-40 mb-4 cursor-pointer" />
                    <p className="text-center lg:text-left text-sm text-gray-500">{GlobalTexts.availableLanguages[language].footerImgDesc}</p>
                </div>

                {/* Menus */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 w-full lg:w-2/6 text-center lg:text-left">
                    <div>
                        <h3 className="uppercase font-semibold mb-3 tracking-wider">{GlobalTexts.availableLanguages[language].footerTitle1}</h3>
                        <ul className="space-y-2 text-sm">
                            {[
                                { label: GlobalTexts.availableLanguages[language].navigation[0].name, path: GlobalTexts.availableLanguages[language].navigation[0].to, section: "presentation" },
                                { label: GlobalTexts.availableLanguages[language].navigation[1].name, path: GlobalTexts.availableLanguages[language].navigation[1].to },
                            ].map(({ label, path, section }) => (
                                <li key={label}>
                                    <a onClick={() => scrollToOrNavigate(path, section)} className="cursor-pointer hover:text-[#C1A45F] transition">{label}</a>
                                </li>
                            ))}
                            <div className="w-full">
                                <p className="flex items-center justify-between cursor-pointer space-y-2 text-sm transition-all duration-300 ease-in-out"
                                    onClick={() => setDropdownOpen(!dropdownOpen)}>
                                    <div className={"flex mx-auto lg:mx-0"}>
                                        {language === 0 ? 'Services' : language === 1 ? 'Services' : 'Dienstleistungen'}
                                        <ChevronDown
                                            className={`ml-2 h-4 w-4 transform transition-transform duration-300 ${dropdownOpen ? "rotate-180" : ""}`}
                                        />
                                    </div>

                                </p>

                                <ul className={`space-y-2 text-sm transition-all duration-300 ease-in-out overflow-hidden ${dropdownOpen ? "max-h-96 mt-2 ml-3" : "max-h-0"}`}>
                                    {[
                                        { label: GlobalTexts.availableLanguages[language].navigation[3].name, path: GlobalTexts.availableLanguages[language].navigation[3].to, section: "presentation" },
                                        { label: GlobalTexts.availableLanguages[language].navigation[4].name, path: GlobalTexts.availableLanguages[language].navigation[4].to },
                                        { label: GlobalTexts.availableLanguages[language].navigation[6].name, path: GlobalTexts.availableLanguages[language].navigation[6].to },
                                        { label: GlobalTexts.availableLanguages[language].navigation[7].name, path: GlobalTexts.availableLanguages[language].navigation[7].to },
                                    ].map(({ label, path }) => (
                                        <li key={label}>
                                            <a onClick={() => scrollToOrNavigate(path)} className="cursor-pointer hover:text-[#C1A45F] transition">• {label}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>


                            {[
                                { label: GlobalTexts.availableLanguages[language].navigation[2].name, path: GlobalTexts.availableLanguages[language].navigation[2].to },
                            ].map(({ label, path, section }) => (
                                <li key={label}>
                                    <a onClick={() => scrollToOrNavigate(path, section)} className="cursor-pointer hover:text-[#C1A45F] transition">{label}</a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h3 className="uppercase font-semibold mb-3 tracking-wider">{GlobalTexts.availableLanguages[language].footerTitle2}</h3>
                        <ul className="space-y-2 text-sm">
                            <li><a href="mailto:contact@avantyjet.com" className="hover:text-[#C1A45F]">{GlobalTexts.availableLanguages[language].email}</a></li>
                            <li><a href="https://www.linkedin.com/company/avantyjet/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C1A45F]">{GlobalTexts.availableLanguages[language].Linkedin}</a></li>
                            <li><a href="https://www.instagram.com/avantyjet/" target="_blank" rel="noopener noreferrer" className="hover:text-[#C1A45F]">{GlobalTexts.availableLanguages[language].Instagram}</a></li>
                            {/*<li><a href="#" className="hover:text-[#C1A45F]">Mentions légales</a></li>*/}
                            {/*<li><a href="#" className="hover:text-[#C1A45F]">Politique de confidentialité</a></li>*/}
                            {/*<li><a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="hover:text-[#C1A45F]">WhatsApp</a></li>*/}
                        </ul>
                    </div>
                </div>

                {/* FAQ large à droite avec scroll */}
                <div className="hidden lg:block w-full text-black md:w-3/6 max-h-[280px] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent mx-auto">
                    <div className={`transition-all duration-500 ease-in-out max-h-[800px] opacity-100`}>
                        <div className="space-y-1.5">
                            {FaqsTexts.availableLanguages[language].faqs.slice(0, 4).map((faq, index) => (
                                <div key={index} className="border border-gray-200 rounded-lg shadow-sm">
                                    <button
                                        className="w-full flex justify-between items-center px-3 py-2 text-left text-sm font-medium hover:text-[#C1A45F] transition"
                                        onClick={() => toggleFAQ(index)}
                                    >
                                        {faq.question}
                                        <ChevronDown
                                            className={`h-4 w-4 ml-4 transform transition-transform duration-300 ${openFAQIndex === index ? "rotate-180 text-[#C1A45F]" : "text-gray-600"}`}
                                        />
                                    </button>

                                    <div className={`transition-all duration-300 ease-in-out ${openFAQIndex === index ? "max-h-[500px] opacity-100" : "max-h-0 overflow-scroll opacity-0"}`}>
                                        <div className="px-3 pb-2 text-black text-xs max-h-[120px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent leading-snug">
                                            {faq.answer.includes("•") ? (
                                                <ul className="list-disc list-inside space-y-0.5">
                                                    {faq.answer.split("\n").map((line, i) =>
                                                        line.trim().startsWith("•") ? (
                                                            <li key={i}>{line.replace("• ", "")}</li>
                                                        ) : (
                                                            <p key={i} className="mb-1">{line}</p>
                                                        )
                                                    )}
                                                </ul>
                                            ) : (
                                                faq.answer.split("\n").map((line, i) => (
                                                    <p key={i} className="mb-1">{line}</p>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>


            </div>
        </footer>


    );
}
